import React from "react";
import { Container, Navbar, Nav } from 'react-bootstrap';
import LogInbtn from "./LogInBtn";
import { LinkContainer } from 'react-router-bootstrap'


import Image from "../images/logo_afp.png";

function NavBarSupervisor() {    
    return (
        <div>
            <Navbar className="navBarCustom" bg="light" expand="lg" >
                <Container>
                    <LinkContainer to='/'>
                        <Navbar.Brand ><img
                            alt=""
                            src={Image}
                            width="80"
                            height="37"
                            className="d-inline-block align-top text-center"
                        /></Navbar.Brand>
                    </LinkContainer>
                    <LinkContainer to='/'>
                        <Nav.Link>Home</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to='/mantenedor'>
                        <Nav.Link>Mantenedor</Nav.Link>
                    </LinkContainer>
                    {/* <LinkContainer to='/carga'>
                        <Nav.Link>Cargar Numeros</Nav.Link>
                    </LinkContainer> */}
                    <LogInbtn/>
                </Container>
            </Navbar>
        </div>
    )
}

export default NavBarSupervisor